<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es.js';

export default {
  props: {
    disabled: {
      type: Boolean,
      deafult: false,
    },
    format: {
      type: String,
      default: "YYYY-MM-DD",
    },
    placeholder: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectedValue: {
      get() {
        return this.$attrs.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    hasErrors() {
      return this.errors.length > 0;
    },
  },
  methods: {
    emitInput(value) {
      this.$emit("input", value);
    },
  },
}
</script>

<template>
  <div class="form-group">
    <label v-if="title">{{ title }}</label>
    <div class="input-group">
      <DatePicker
        v-model="selectedValue"
        :disabled="disabled"
        type="date"
        format='DD-MM-YYYY'
        :valueType="format"
        :placeholder="placeholder"
      />
      <span class="invalid-feedback" role="alert" :class="{ 'd-block': hasErrors }">
        <strong>{{ errors[0] }}</strong>
      </span>
    </div>
  </div>
</template>

<style>
.mx-datepicker {
  width: 100%;
}
</style>